import MIcon from 'app/ui/MIcon/MIcon';
import React from 'react';
import { Link } from 'react-router-dom';
import { IMenu } from '../MToolbar.model';

import classes from './MToolbarMobileMenu.module.scss';

interface Props {
  containerRef: React.RefObject<HTMLDivElement>;
  className?: string;
  menu: IMenu[];
  onExitBtnClick: () => void;
  onMenuItemClick: () => void;
}

const MToolbarMobileMenuView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div ref={props.containerRef} className={`${classes['container']} ${props.className || ''}`}>
      <button onClick={props.onExitBtnClick} type="button">
        <MIcon className={classes['exit']} name="cisX"></MIcon>
      </button>
      <menu className={classes['menu']}>
        <ul className={classes['menuList']}>
          {props.menu.map((menu: IMenu, index: number) => {
            return (
              <li key={index}>
                <Link to={menu.to} className={classes['menuItem']} onClick={props.onMenuItemClick}>
                  {menu.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </menu>
    </div>
  );
};

MToolbarMobileMenuView.displayName = 'MToolbarMobileMenuView';
MToolbarMobileMenuView.defaultProps = {};

export default MToolbarMobileMenuView;
